enum CheckboxMode {
  UniDirection = 'UniDirection',
  MultiDirection = 'MultiDirection',
}
export default CheckboxMode;
